<template>
<dialog-reset
    :title="dialogTitle"
    :visible.sync="visible"
    width="1060px"
    top="5vh"
    height="75vh"
    :appendToBody="false"
    :modalShow="false"
    :zoomShow="false"
    @close="handleClose"
  >
    <div class="section-title">基本信息</div>
    <avue-form ref="baseForm" v-model="form" :option="optionForm" />

    <div class="section-title ">仓库与库位</div>
    <div class="location-section">
      <div class="dialog-left">
        <div class="section-subtitle">选择仓库</div>
        <el-input
          v-model="storeSearchKeyword"
          placeholder="搜索仓库"
          prefix-icon="el-icon-search"
          class="search-input"
          size="small"
          @input="filterStores"
        />
        <div class="store-list">
          <div
            v-for="store in filteredStores"
            :key="store.storeNo"
            :class="['store-item', {
              active: isStoreSelected(store),
              'current-tab': currentStoreTab === store.storeNo,
              disabled: isView
            }]"
            @click="!isView && toggleStore(store)"
          >
            <div class="store-name">{{ store.storeName }}</div>
            <div class="store-code">仓库编号: {{ store.storeNo }}</div>
            <i
              v-if="!isView && isStoreSelected(store)"
              class="el-icon-close store-remove"
              @click.stop="removeStore(store)"
            ></i>
          </div>
        </div>
        <div class="selected-stores-info" v-if="selectedStores.length > 0">
          已选择{{ selectedStores.length }}个仓库
        </div>
      </div>
      <div class="dialog-right">
        <div class="section-subtitle">选择库位</div>
        <div v-if="selectedStores.length === 0" class="location-empty">
          请先选择仓库
        </div>
        <div v-else>
          <div class="current-store" v-if="currentStoreTab">
            当前仓库: {{ getCurrentStoreName() }}
            <span class="selected-count">已选择{{ getCurrentStoreLocations().length }}个库位</span>
          </div>
          <div class="location-grid" v-if="currentStoreTab">
            <div
              v-for="location in currentLocationList"
              :key="location.locationCode"
              :class="['location-item', {
                selected: isLocationSelected(location),
                disabled: location.status === '占用' || location.status === '维护中' || isView
              }]"
              @click="!isView && toggleLocation(location)"
            >
              <div class="location-code">{{ location.locationCode }}</div>
              <div class="location-status">{{ location.locationName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span v-if="!isView" slot="dialog_footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import { getStoreList, getLocationList, uploadEndpoint } from '../api'
import {getDate} from "@/util/date";
import {changeTypeOptions} from "@/views/basic-info/stockLease/const";

export default {
  name: 'StockLeaseCreateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create' // create | edit
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.getDefaultForm(),
      optionForm: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 140,
        column: [
          {
            label: '租约名称',
            prop: 'leaseName',
            span: 8,
            rules: [{ required: true, message: '请输入租约名称', trigger: 'blur' }]
          },

          {
            label: '货主名称',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            search: true, // 查询是否显示
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select', // 接口统一换位这个
            //回显统一配置这个
            props: {
              label: 'deptName',
              value: 'id'
            },
            span:8,
          },

          {
            label: '租赁总面积（㎡）',
            prop: 'totalArea',
            type: 'number',
            span: 8,
            precision: 2,
            min: 0,
            valueDefault: null
          },
          {
            label: '租赁开始日期',
            prop: 'lease_start_date',
            type: 'date',
            span: 8,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [{ required: true, message: '请选择租赁开始日期', trigger: 'change' }]
          },
          {
            label: '租赁结束日期',
            prop: 'lease_end_date',
            type: 'date',
            span: 8,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [{ required: true, message: '请选择租赁结束日期', trigger: 'change' }]
          },
          {
            label: '签约日期',
            prop: 'sign_date',
            type: 'date',
            span: 8,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          // {
          //   label: '租约状态',
          //   prop: 'leaseStatus',
          //   span: 8
          // },

          {
            label: '是否自动续租',
            prop: 'autoRenew',
            type: 'select',
            span: 8,
            dicData: [
              { label: '是', value: 1 },
              { label: '否', value: 0 }
            ]
          },
          {
            label: '提前通知期（天）',
            prop: 'reminderDays',
            type: 'number',
            span: 8,
            min: 0
          },
          {
            label: '提前提醒已发送',
            prop: 'reminderSent',
            type: 'select',
            span: 8,
            dicData: [
              { label: '是', value: 1 },
              { label: '否', value: 0 }
            ]
          },{
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            span: 8,
            minRows: 1,
          },
          {
            label: '变更类型',
            prop: 'changeType',
            type: 'select',
            span: 8,
            dicData: changeTypeOptions,
            display: () => ['change', 'view'].includes(this.mode),
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (this.mode === 'change' && (value === undefined || value === null || value === '')) {
                    callback(new Error('请选择变更类型'))
                  } else {
                    callback()
                  }
                },
                trigger: 'change'
              }
            ]
          },

          {
            label: '变更备注',
            prop: 'changeRemark',
            span: 8,
            display: () => ['change', 'view'].includes(this.mode)
          },
          {
            label: '合同附件',
            prop: 'contractAttachment',
            type: 'upload',
            span: 8,
            action: uploadEndpoint,
            dataType: 'string',
            propsHttp: { res: 'data', url: 'link' },
            limit: 1,
            multiple: false,
            listType: 'text',
            tip: '支持上传单个附件'
          },
        ]
      },
      storeList: [],
      filteredStores: [],
      storeSearchKeyword: '',
      selectedStores: [], // 选中的仓库列表
      currentStoreTab: null, // 当前查看的仓库tab
      storeLocationMap: {}, // 每个仓库对应的库位列表 { storeNo: [locations] }
      storeSelectedLocationsMap: {}, // 每个仓库选中的库位 { storeNo: [selectedLocations] }
      pendingInitData: null,

    }
  },
  computed: {
    dialogTitle () {
      if (this.mode === 'edit') return '编辑租约'
      if (this.mode === 'change') return '变更租约'
      if (this.mode === 'view') return '租约详情'
      return '新增租约'
    },
    isView () {
      return this.mode === 'view'
    },
    currentLocationList () {
      if (!this.currentStoreTab) return []
      return this.storeLocationMap[this.currentStoreTab] || []
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadStores().then(() => {
          this.applyInitialData()
        })
      } else {
        this.resetState()
      }
    },
    mode: {
      handler (val) {
        this.optionForm.detail = val === 'view'
      },
      immediate: true
    },
    initialData: {
      handler () {
        if (this.visible) {
          this.applyInitialData()
        } else {
          this.pendingInitData = { ...(this.initialData || {}) }
        }
      },
      deep: true
    }
  },
  methods: {
    getDefaultForm () {
      return {
        lease_start_date: getDate('now','YYYY-MM-DD'),
        lease_end_date: getDate('now','YYYY-MM-DD'),
        sign_date: getDate('now','YYYY-MM-DD'),
      }
    },
    async loadStores () {
      try {
        const res = await getStoreList()
        if (res.data && res.data.code === 200) {
          this.storeList = res.data.data || []
          this.filteredStores = [...this.storeList]
        }
        return this.storeList
      } catch (error) {
        this.$message.error('获取仓库列表失败')
        return []
      }
    },
    filterStores () {
      if (!this.storeSearchKeyword) {
        this.filteredStores = [...this.storeList]
        return
      }
      this.filteredStores = this.storeList.filter(store =>
        store.storeName.includes(this.storeSearchKeyword) ||
        store.storeNo.includes(this.storeSearchKeyword)
      )
    },
    async toggleStore (store) {
      const index = this.selectedStores.findIndex(s => s.storeNo === store.storeNo)
      if (index > -1) {
        // 如果仓库已选中，只是切换显示该仓库的库位
        this.currentStoreTab = store.storeNo
      } else {
        // 选择仓库
        this.selectedStores.push(store)
        // 加载该仓库的库位列表
        await this.loadLocations(store.storeNo)
        // 切换显示该仓库的库位
        this.currentStoreTab = store.storeNo
      }
    },
    removeStore (store) {
      const index = this.selectedStores.findIndex(s => s.storeNo === store.storeNo)
      if (index > -1) {
        this.selectedStores.splice(index, 1)
        delete this.storeLocationMap[store.storeNo]
        delete this.storeSelectedLocationsMap[store.storeNo]
        // 如果当前显示的是被删除的仓库，切换到第一个仓库
        if (this.currentStoreTab === store.storeNo) {
          this.currentStoreTab = this.selectedStores.length > 0 ? this.selectedStores[0].storeNo : null
        }
      }
    },
    async loadLocations (storeNo) {
      try {
        const res = await getLocationList(storeNo)
        if (res.data && res.data.code === 200) {
          this.$set(this.storeLocationMap, storeNo, res.data.data || [])
          // 初始化该仓库的选中库位列表
          if (!this.storeSelectedLocationsMap[storeNo]) {
            this.$set(this.storeSelectedLocationsMap, storeNo, [])
          }
        }
        return this.storeLocationMap[storeNo] || []
      } catch (error) {
        this.$message.error('获取库位列表失败')
        return []
      }
    },
    toggleLocation (location) {
      if (location.status === '占用' || location.status === '维护中') return
      if (!this.currentStoreTab) return

      const selectedList = this.storeSelectedLocationsMap[this.currentStoreTab] || []
      const index = selectedList.findIndex(loc => loc.locationCode === location.locationCode)
      if (index > -1) {
        selectedList.splice(index, 1)
      } else {
        selectedList.push(location)
      }
      this.$set(this.storeSelectedLocationsMap, this.currentStoreTab, selectedList)
    },
    isStoreSelected (store) {
      return this.selectedStores.some(s => s.storeNo === store.storeNo)
    },
    isLocationSelected (location) {
      if (!this.currentStoreTab) return false
      const selectedList = this.storeSelectedLocationsMap[this.currentStoreTab] || []
      return selectedList.some(loc => loc.locationCode === location.locationCode)
    },
    getCurrentStoreName () {
      if (!this.currentStoreTab) return ''
      const store = this.selectedStores.find(s => s.storeNo === this.currentStoreTab)
      return store ? `${store.storeName} (${store.storeNo})` : ''
    },
    getCurrentStoreLocations () {
      if (!this.currentStoreTab) return []
      return this.storeSelectedLocationsMap[this.currentStoreTab] || []
    },
    async handleSubmit () {
      if (this.isView) {
        this.handleClose()
        return
      }
      this.$refs.baseForm.validate(valid => {
        if (!valid) return
        if (this.selectedStores.length === 0) {
          this.$message.warning('请至少选择一个仓库')
          return
        }
        // 检查是否至少有一个仓库选择了库位
        const hasSelectedLocations = Object.values(this.storeSelectedLocationsMap).some(locations => locations && locations.length > 0)
        if (!hasSelectedLocations) {
          this.$message.warning('请至少选择一个库位')
          return
        }
        if (this.mode === 'change' && !this.form.changeType) {
          this.$message.warning('请选择变更类型')
          return
        }
        // 生成包含所有仓库和库位的 list
        const list = []
        this.selectedStores.forEach(store => {
          const locations = this.storeSelectedLocationsMap[store.storeNo] || []
          locations.forEach(loc => {
            list.push({
              stockNo: store.storeNo,
              stockName: store.storeName,
              locationCode: loc.locationCode,
              locationName: loc.locationName
            })
          })
        })
        const payload = {
          ...this.form,
          list,
          actionType: this.mode === 'change' ? 'change' : (this.mode === 'edit' ? 'edit' : 'create')
        }
        this.$emit('submit', payload)
      })
    },
    handleClose () {
      this.$emit('update:visible', false)
    },
    async applyInitialData () {
      const data = Object.keys(this.initialData || {}).length ? this.initialData : (this.pendingInitData || {})
      if (!data || !Object.keys(data).length) return
      this.form = {
        ...this.getDefaultForm(),
        ...data
      }
      // 从 list 中提取仓库和库位信息
      const listFromData = Array.isArray(data.list) && data.list.length ? data.list : []
      if (listFromData.length === 0) return

      // 按仓库分组
      const storeMap = {}
      listFromData.forEach(item => {
        const storeNo = item.stockNo || item.storeNo
        const storeName = item.stockName || item.storeName
        if (storeNo && storeName) {
          if (!storeMap[storeNo]) {
            storeMap[storeNo] = {
              storeNo,
              storeName,
              locations: []
            }
          }
          if (item.locationCode) {
            storeMap[storeNo].locations.push({
              locationCode: item.locationCode,
              locationName: item.locationName
            })
          }
        }
      })

      // 加载每个仓库的库位列表并回显选中的库位
      const storePromises = Object.values(storeMap).map(async (storeInfo) => {
        await this.loadLocations(storeInfo.storeNo)
        // 回显该仓库选中的库位
        const locationList = this.storeLocationMap[storeInfo.storeNo] || []
        const selectedLocations = storeInfo.locations
          .filter(loc => loc.locationCode)
          .map(loc => {
            const found = locationList.find(item => item.locationCode === loc.locationCode) || {}
            return {
              ...found,
              locationCode: loc.locationCode,
              locationName: loc.locationName || found.locationName
            }
          })
        this.$set(this.storeSelectedLocationsMap, storeInfo.storeNo, selectedLocations)
        return {
          storeNo: storeInfo.storeNo,
          storeName: storeInfo.storeName
        }
      })

      const stores = await Promise.all(storePromises)
      this.selectedStores = stores
      // 设置第一个仓库为当前tab
      if (stores.length > 0) {
        this.currentStoreTab = stores[0].storeNo
      }
      this.pendingInitData = null
    },
    safeParseExt (ext) {
      if (!ext) return []
      try {
        const parsed = typeof ext === 'string' ? JSON.parse(ext) : ext
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    resetState () {
      this.form = this.getDefaultForm()
      this.storeList = []
      this.filteredStores = []
      this.storeSearchKeyword = ''
      this.selectedStores = []
      this.currentStoreTab = null
      this.storeLocationMap = {}
      this.storeSelectedLocationsMap = {}
      this.pendingInitData = null
      this.optionForm.detail = this.mode === 'view'
      this.$nextTick(() => {
        this.$refs.baseForm && this.$refs.baseForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}
.location-section {
  display: flex;
  gap: 16px;
  min-height: 380px;
}
.dialog-left {
  width: 280px;
  border-right: 1px solid #e6e6e6;
  padding-right: 12px;
}
.search-input {
  margin-bottom: 10px;
}
.store-list {
  max-height: 320px;
  overflow-y: auto;
}
.store-item {
  padding: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}
.store-item:hover:not(.active):not(.current-tab) {
  border-color: #409eff;
  background-color: #f0f9ff;
}
.store-item.active {
  border-color: #409eff;
  background-color: #e6f7ff;
  border-width: 1px;
}
.store-item.current-tab {
  border-color: #409eff;
  background-color: #b3d8ff;
  border-width: 2px;
  font-weight: 600;
}
.store-item.current-tab:hover {
  border-color: #66b1ff;
  background-color: #b3d8ff;
}
.store-item.active:hover:not(.current-tab) {
  border-color: #66b1ff;
  background-color: #d9ecff;
}
.store-item.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.store-item.disabled:hover {
  border-color: #e6e6e6;
  background-color: transparent;
}
.store-name {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  padding-right: 20px;
}
.store-code {
  font-size: 12px;
  color: #666;
}
.store-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  z-index: 1;
}
.store-remove:hover {
  color: #f56c6c;
}
.selected-stores-info {
  margin-top: 10px;
  padding: 8px;
  background-color: #f0f9ff;
  border-radius: 4px;
  font-size: 12px;
  color: #409eff;
  text-align: center;
}
.dialog-right {
  flex: 1;
  padding-left: 4px;
}
.current-store {
  margin-bottom: 10px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
.selected-count {
  float: right;
  color: #409eff;
}
.location-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}
.location-item {
  padding: 12px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}
.location-item:hover:not(.disabled) {
  border-color: #409eff;
  background-color: #f0f9ff;
}
.location-item.selected {
  border-color: #409eff;
  background-color: #e6f7ff;
}
.location-item.disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}
.location-code {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 4px;
}
.location-status {
  font-size: 12px;
  color: #666;
}
.location-empty {
  margin-top: 30px;
  color: #999;
  text-align: center;
}
.change-form {
  margin-top: 6px;
}
</style>

